import UserAccountModelBase from '../_generated/modelBases/user-account-model-base';

export default class UserAccountModel extends UserAccountModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
